import { useGetPendingComplaintsFeedbackQuery } from '../../services';
import { PendingComplaintsFeedbackRequest } from '../../types/dto/confirrm-reflection-request';

export function GetConfirmReflectionRequest(pendingComplaintsFeedbackRequest: PendingComplaintsFeedbackRequest) {
  const {
    data: complaintFeedback,
    isLoading,
    refetch
  } = useGetPendingComplaintsFeedbackQuery(pendingComplaintsFeedbackRequest!, {
    skip: !pendingComplaintsFeedbackRequest,
    refetchOnMountOrArgChange: true
  });

  return {
    complaintFeedback: complaintFeedback?.data.rows || [],
    complaintFeedbackCount: Number(complaintFeedback?.data.count),
    refetch: refetch ?? (() => {}),
    isLoading
  };
}
